import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import ProductFeatures from '../views/ProductFeatures.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/products',
    name: 'Products',
    component: ProductFeatures
  },
  {
    path: '/cooperation',
    name: 'Cooperation',
    component: () => import('../views/Cooperation.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router
